import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryParams, User } from '../../types';
import { Paginated, PaginationService } from '../../services/api-handlers/pagination';
import { resolveApiCall } from '../../services/api-handlers/api-resolver';
import SortingService from '../../services/sorting';
import { UserApi } from '../../services/end-points';
import { ThunkConfig } from '../configure-store';

export const listUsers = createAsyncThunk<Paginated<User>, QueryParams, ThunkConfig>(
    'user/list',
    async (payload, thunkAPI) => {
        const { getState } = thunkAPI;
        const { user } = getState();
        const { filters, sorting, ...rest } = payload;

        return PaginationService.resolveApiCall(
            thunkAPI,
            user,
            async () =>
                UserApi.list({
                    ...filters,
                    ...SortingService.makeOrder(sorting),
                    ...rest,
                }),
            payload.page,
            user.data,
        );
    },
);

export const getUser = createAsyncThunk<User, { userId: string; onError: (data: any) => any }, ThunkConfig>(
    'user/current',
    async (payload, thunkAPI) => {
        const { getState } = thunkAPI;
        const { user } = getState();
        const { userId, onError } = payload;

        return resolveApiCall(thunkAPI, user, async () => (await UserApi.get(userId)).data, onError);
    },
);
